
import { Vue, Component } from 'vue-property-decorator'
import { fetchAttempts } from '@/modules/biometric'

@Component
export default class Attempts extends Vue {
  items: any[] = []
  total: number = 0
  page: number = 1
  size: number = 20

  national_id: string = ''
  country: string = ''
  successStr: string = ''
  start_date: string = ''
  end_date: string = ''

  mounted(){ this.loadAttempts(1) }

  async loadAttempts(page: number){
    this.page = page
    const resp = await fetchAttempts({
      national_id: this.national_id || undefined,
      country: this.country || undefined,
      success: this.successStr === '' ? undefined : this.successStr === 'true',
      start_date: this.start_date || undefined,
      end_date: this.end_date || undefined,
      page: this.page,
      size: this.size,
    })
    this.items = resp.data.items || []
    this.total = resp.data.total || 0
  }

  prevPage(){ if(this.page>1) this.loadAttempts(this.page-1) }
  nextPage(){ this.loadAttempts(this.page+1) }
}
